import React, { useState, useEffect } from "react";
import useAppAccessor from "../../../../hooks/useappAccessor";
import "./style.css";
import {
  Facebooklink,
  Messanger,
  Instagramlink,
  Link,
  Linkedinlink,
  Pinterestlink,
  Twitterlink,
  NoPhoto,
  Whatsapplink,
  Star_Inactive,
  Star,
} from "../../../../assets/icons";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import {
  setInteractionData,
  getProductDetail,
} from "../../../interactions/interaction.actions";
import _, { set } from "lodash";
import BottomSheet from "../../../../components/bottomSheet";
import { callEvent } from "../../../../services/main.service";
import { getBrandColor } from "../../../../utils/brand.util";

const isHost = () => {
  return window.location.href.indexOf("/stream") > -1;
};

const ZyiaUrl = "https://www.myzyia.com/";
const TranontUrl = "https://www.tranont.com/";
const PartnerCoUrl = "partner.co";

const decimalComponent = (number: any, client: any) => {
  if (number == undefined) return;
  if (number.includes("-")) {
    const numb1: any = number.toString().split("-")[0];
    const numb2: any = number.toString().split("-")[1];
    const [integerPart, decimalPart] = numb1.toString().split(".");
    const [integerPart_2, decimalPart_2] = numb2.toString().split(".");

    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart ? `${integerPart}.` : `${integerPart}`}
          {decimalPart ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
        -
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15, marginLeft: 5 }}
        >
          {decimalPart_2 ? `${integerPart_2}.` : `${integerPart_2}`}
          {decimalPart_2 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_2}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  } else if (number.includes(",")) {
    const [integerPart_3, decimalPart_3] = number.toString().split(",");
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart_3 ? `${integerPart_3},` : `${integerPart_3}`}
          {decimalPart_3 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_3}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  } else {
    var [integerPart_3, decimalPart_3] = number.toString().split(".");
    if (decimalPart_3.includes(" ")) {
      decimalPart_3 = decimalPart_3.split(" ")[0];
    }
    return (
      <div className="flex items-center justify-center">
        <div
          className="text-base"
          style={{ position: "relative", marginRight: 15 }}
        >
          {decimalPart_3 ? `${integerPart_3}.` : `${integerPart_3}`}
          {decimalPart_3 ? (
            <span
              className="text-[10px] font-semibold"
              style={{ position: "absolute", bottom: 3 }}
            >{`${decimalPart_3}`}</span>
          ) : (
            <span> </span>
          )}
        </div>
      </div>
    );
  }
};

const decodeHtmlEntities = (html: string | undefined): string => {
  if (!html) return "";
  try {
    // 创建textarea元素来利用浏览器的HTML实体解码功能
    const textarea = document.createElement("textarea");
    textarea.innerHTML = html;

    // 如果是简单的HTML实体（如&reg;, &copy;等），textarea.value会处理
    // 但对于更复杂的HTML内容，可能需要额外的清理
    const decodedText = textarea.value;

    // 如果解码后的文本为空但原始文本不为空，则返回原始文本
    // 这可能发生在某些浏览器环境中
    return decodedText || html;
  } catch (error) {
    // 如果发生错误，返回原始文本
    console.error("Error decoding HTML entities:", error);
    return html;
  }
};

const isMobile =
  window.innerWidth < 768 ||
  /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

const ProductsListing = (mobileClick: any) => {
  const dispatch = useAppDispatch();
  const { getInteractions, getLiveMainData, getUserData } = useAppAccessor();
  const { interactionData, productDetails } = getInteractions();
  const { joinData, hostTime, createStreamData, infoData } = getLiveMainData();
  const { referrer_user, client } = getUserData();
  const { configurationData } = getLiveMainData();
  const [selectedItemPos, setSelectedItemPos] = useState<any>(0);
  const [interactionsAllData, setInteractionsAllData] = useState<any>([]);
  const [isShopInteraction, setIsShopInteraction] = useState(false);
  const { joinWithAttendeeData } = getLiveMainData();
  const [attendeList, setAtteendeList] = useState<any>([]);
  const temparray: any = [1, 2, 3, 4, 5, 6];
  const environment = process.env.NODE_ENV;

  useEffect(() => {
    if (interactionData.length > 0) {
      setInteractionsAllData(interactionData);
      setTimeout(() => {
        const result = interactionData.find((obj: any) => obj.featured == true);
        // console.log("resulttt==> shaam", result);
        if (result?.interaction_id) {
          scrollToElement(result?.interaction_id);
        }
      }, 100);
    } else if (interactionData.length == 0) {
      if (interactionsAllData.length > 0) {
        setInteractionsAllData(interactionData);
      }
    }
  }, [interactionData]);

  useEffect(() => {
    setAtteendeList(joinWithAttendeeData.attendees);
  }, [joinWithAttendeeData]);

  const getIconManualInteraction = (type: any) => {
    switch (type) {
      case "Facebook":
        return Facebooklink;
      case "Instagram":
        return Instagramlink;
      case "LinkedIn":
        return Linkedinlink;
      case "Twitter":
        return Twitterlink;
      case "Pinterest":
        return Pinterestlink;
      case "Messenger":
        return Messanger;
      case "WhatsApp":
        return Whatsapplink;
      default:
        return NoPhoto;
    }
  };

  const getInteractionTypeCheck = (type: any) => {
    switch (type) {
      case "social":
        return false;
      case "link":
        return false;
      default:
        return true;
    }
  };

  const getLinkValidation = (type: any, url: any) => {
    if (type == "link") {
      if (url == "") {
        return false;
      } else {
        return true;
      }
    }
  };

  const showObject = (data: any) => {
    if (data?.attributes?.shouldShow) {
      return true;
    } else {
      return false;
    }
  };

  const replaceHost = (url1: string, url2: string) => {
    if (url2) {
      const originalUrl = new URL(url1);
      const newHostUrl = new URL(url2);

      originalUrl.host = newHostUrl.host;

      return originalUrl.toString();
    } else {
      return url1;
    }
  };

  const attachReferer = (url: string, thirdPartyUsername: string): string => {
    let link = url;

    if (!/^https?:\/\//i.test(url)) {
      link = `https://${url}`;
    }

    const finalUrl = new URL(link);

    finalUrl.searchParams.set("share", thirdPartyUsername);

    // console.log(finalUrl.href);
    var newLink = finalUrl.href;
    const newWindow = window.open(newLink, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;

    return "";
  };

  const handleCliclonProduct = (data: any) => {
    // console.log("selected Item===>", data);

    if (isHost() !== true) {
      var resp = joinData;
      if (referrer_user) {
        callEvent([
          {
            event_data: {
              attendee_email: resp["email"],
              attendee_first: resp["given_name"],
              attendee_id: resp["attendee_id"],
              attendee_role: "attendee",
              attendee_last: resp["family_name"],
              client_id: infoData["hostModel"]["clientId"],
              stream_id: joinWithAttendeeData["stream_id"],
              stream_instance_id: resp["stream_instance_id"],
              user_id: infoData["hostModel"]["userId"],
              interaction_id: data.interaction_id,
              interaction_type: data.attributes.type,
              interaction_label: data.attributes.label,
              interaction_action: data.attributes.action,
              issuer_referrer_id: referrer_user.webhook_referrer_id,
              issuer_referrer_name: referrer_user.webhook_referrer_name,
              interaction_imageUrl: data.style.thumbnail_url,
              elapsed_seconds: hostTime,
              date: new Date().toUTCString(),
            },
            event_type: "interaction_clicked",
          },
        ]);
      } else {
        callEvent([
          {
            event_data: {
              attendee_email: resp["email"],
              attendee_first: resp["given_name"],
              attendee_id: resp["attendee_id"],
              attendee_role: "attendee",
              attendee_last: resp["family_name"],
              client_id: infoData["hostModel"]["clientId"],
              stream_id: joinWithAttendeeData["stream_id"],
              stream_instance_id: resp["stream_instance_id"],
              user_id: infoData["hostModel"]["userId"],
              interaction_id: data.interaction_id,
              interaction_type: data.attributes.type,
              interaction_label: data.attributes.label,
              interaction_action: data.attributes.action,
              interaction_imageUrl: data.style.thumbnail_url,
              elapsed_seconds: hostTime,
              date: new Date().toUTCString(),
            },
            event_type: "interaction_clicked",
          },
        ]);
      }
    }

    if (isHost() === true) {
      let tempArray: any = [];
      tempArray = _.cloneDeep(interactionsAllData);
      setInteractionsAllData([]);
      tempArray.forEach((element: any) => {
        if (element.interaction_id === data.interaction_id) {
          element.featured = !element.featured;
          if (element.featured) {
            callEvent([
              {
                event_data: {
                  stream_id: createStreamData["stream_id"],
                  stream_instance_id: createStreamData["stream_instance_id"],
                  interaction_id: data.interaction_id,
                  elapsed_seconds: hostTime,
                  date: new Date().toUTCString(),
                },
                event_type: "feautred_interaction",
              },
            ]);
          } else {
            callEvent([
              {
                event_data: {
                  stream_id: createStreamData["stream_id"],
                  stream_instance_id: createStreamData["stream_instance_id"],
                  interaction_id: data.interaction_id,
                  elapsed_seconds: hostTime,
                  date: new Date().toUTCString(),
                },
                event_type: "un_feautred_interaction",
              },
            ]);
          }
        } else {
          element.featured = false;
        }
      });
      setInteractionsAllData(tempArray);
    } else if (data?.real_type === "shop_com") {
      var tmpProduct = productDetails.filter(
        (item: any) => item?.id == data?.interaction_id
      )[0];
      // console.log("tmpProduct==>", tmpProduct);
      if (tmpProduct) {
        tmpProduct["fromCarsoul"] = true;
        tmpProduct["fromCarsoul12"] = Math.random();
        dispatch(getProductDetail(tmpProduct));
      }
    } else if (data?.real_type === "partner.co") {
      var tmpProduct = productDetails.filter(
        (item: any) => item?.id == data?.interaction_id
      )[0];
      // console.log("tmpProduct==>", tmpProduct);
      if (tmpProduct) {
        tmpProduct["fromCarsoul"] = true;
        tmpProduct["fromCarsoul12"] = Math.random();
        dispatch(getProductDetail(tmpProduct));
       }
    }
    else if (data?.real_type === "tranont") {
      var tmpProduct = productDetails.filter(
        (item: any) => item?.id == data?.interaction_id
      )[0];
      // console.log("tmpProduct==>", tmpProduct);
      if (tmpProduct) {
        tmpProduct["fromCarsoul"] = true;
        tmpProduct["fromCarsoul12"] = Math.random();
        dispatch(getProductDetail(tmpProduct));
      }
    } else if (data?.interaction_type !== "media") {
      openLinkNewTab(data?.attributes?.action);
    } else if (extractBaseUrl(data?.attributes?.action) === TranontUrl) {
      // console.log("TranontUrl==>", data?.attributes?.action);
      attachReferer(
        data?.attributes?.action,
        referrer_user?.third_party_username
          ? referrer_user?.third_party_username
          : joinWithAttendeeData?.issuer_metadata?.third_party_username
      );
    }  else if (extractBaseUrl(data?.attributes?.action).includes(PartnerCoUrl)) {
      try {
        const url = new URL(data?.attributes?.action);
        const pathSegments = url.pathname.split("/").filter(Boolean);
        
        const thirdPartyUsername = referrer_user?.third_party_username || 
          joinWithAttendeeData?.issuer_metadata?.third_party_username;
        
        if (thirdPartyUsername && pathSegments.length > 0) {
          pathSegments[pathSegments.length - 1] = thirdPartyUsername;
          url.pathname = "/" + pathSegments.join("/");
        }
        
        const newUrl = url.toString();
        openLinkNewTab(newUrl);
      } catch (error) {
        openLinkNewTab(data?.attributes?.action);
      }
    } 
    else if (
      data?.attributes?.action.includes("myarieyl") ||
      data?.attributes?.action.includes("eexcelusa")
    ) {
      if (referrer_user?.media_interaction_replacement_url) {
        openLinkNewTab(
          replaceHost(
            data?.attributes?.action,
            referrer_user.media_interaction_replacement_url
          )
        );
      } else {
        openLinkNewTab(data?.attributes?.action);
      }
    } else if (extractBaseUrl(data?.attributes?.action) === ZyiaUrl) {
      if (
        data?.interaction_subtype === "facebook" ||
        data?.interaction_subtype === "linkedin" ||
        data?.interaction_subtype === "twitter" ||
        data?.interaction_subtype === "instagram"
      ) {
        meidaAttributionShopifyClick(
          data?.attributes?.action,
          data?.attributes?.label,
          data?.interaction_id,
          joinWithAttendeeData ? attendeList[0]?.attendee_id : "",
          referrer_user?.shop_site_name
            ? referrer_user.shop_site_name
            : joinWithAttendeeData?.issuer_metadata?.shop_site_name,
          referrer_user?.shop_site_name
        );
      } else {
        shopifyAttributionClick(
          data?.attributes?.action,
          data?.attributes?.label,
          data?.attributes.assetId,
          joinWithAttendeeData ? attendeList[0]?.attendee_id : "",
          joinWithAttendeeData?.issuer_metadata?.shop_site_name,
          referrer_user?.shop_site_name
        );
      }
    } else if (
      data?.interaction_subtype === "facebook" ||
      data?.interaction_subtype === "linkedin" ||
      data?.interaction_subtype === "twitter" ||
      data?.interaction_subtype === "instagram"
    ) {
      meidaAttributionClick(
        data?.attributes?.action,
        data?.attributes?.label,
        data?.interaction_id,
        joinWithAttendeeData ? attendeList[0]?.attendee_id : "",
        referrer_user?.third_party_username
          ? referrer_user?.third_party_username
          : joinWithAttendeeData?.issuer_metadata?.third_party_username,
        referrer_user
      );
    } else {
      attachUtm(
        data?.attributes?.action,
        joinWithAttendeeData ? attendeList[0]?.attendee_id : "",
        referrer_user?.third_party_username
          ? referrer_user?.third_party_username
          : joinWithAttendeeData?.issuer_metadata?.third_party_username,
        data
      );
    }
  };

  const attachUtm = (
    url: string,
    clientId: string,
    thirdPartyUsername: string,
    interaction: any
  ): string => {
    let link = url;

    if (!/^https?:\/\//i.test(url)) {
      link = `https://${url}`;
    }

    const finalUrl = new URL(link);

    let utmSource = "verbLive";
    let utmMedium = "verbLive";
    let campaign = "";

    campaign = extractMarketamer(clientId);

    let utmTerm = "";
    if (interaction?.attributes.label) {
      utmTerm = interaction.attributes.label
        .replace(/ /g, "_")
        .replace(/[^a-zA-Z0-9_]/g, "");
    }

    const utmContent =
      interaction?.attributes.assetId || interaction?.interactionId;

    const utmDistributor = thirdPartyUsername || "";

    // console.log(referrer_user, "referrer_user");

    finalUrl.searchParams.set("utm_source", utmSource);
    finalUrl.searchParams.set("utm_medium", utmMedium);
    finalUrl.searchParams.set("utm_campaign", campaign);
    finalUrl.searchParams.set("utm_term", utmTerm || "");
    finalUrl.searchParams.set("utm_distributor", utmDistributor);
    finalUrl.searchParams.set("utm_content", utmContent || "");

    const MAShopHosts = [
      "www.shop.com",
      "www.isotonix.com",
      "www.tlsslim.com",
      "www.nutrametrix.com",
      "www.motivescosmetics.com",
      "www.lumieredevie.com",
      "www.getlayered.com",
      "mys.shop.com",
    ];
    var isMA = false;
    if (MAShopHosts.includes(finalUrl.host)) {
      finalUrl.searchParams.set("sourceid", "4444");
      isMA = true;
    }

    var newLink = finalUrl.href;
    if (isMA) {
      if (referrer_user?.media_interaction_replacement_url) {
        var userId = extractNumberFromUrl(
          referrer_user?.media_interaction_replacement_url
        );
        // console.log(userId, "++userId");
        if (extractBaseUrl(newLink).includes("shop.com")) {
          finalUrl.searchParams.set("credituser", "R" + userId);
          var link1 =
            replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId) +
            referrer_user?.third_party_username +
            extractPathAndQuery(finalUrl.href);
          link1 = link1.replace("/testportalusaqashp", "");
          // console.log(link1, "++linke1");
          const newWindow = window.open(link1, "_blank", "noopener,noreferrer");
          if (newWindow) newWindow.opener = null;
          return "";
        } else if (extractBaseUrl(newLink).includes("motivescosmetics.com")) {
          const urlObject = new URL(url);
          const urlObjectReferenced = new URL(
            referrer_user?.media_interaction_replacement_url
          );
          const newBaseUrl = `${urlObject.protocol}//${urlObjectReferenced.hostname}`;
          var link1 = "";
          if (interaction.attributes.isMAShop === true) {
            link1 =
              replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId) +
              referrer_user?.third_party_username +
              extractPathAndQuery(finalUrl.href);
          } else {
            link1 =
              replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId) +
              extractPathAndQuery(finalUrl.href);
          }
          // console.log(finalUrl.href, "++linke1");
          // console.log(link1, "++linke1");
          link1 = link1.replace(
            "/testportalusaqashp",
            "/" + referrer_user?.third_party_username
          );
          // console.log(replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId));
          // console.log(link1, "++linke1");
          const newWindow = window.open(link1, "_blank", "noopener,noreferrer");
          if (newWindow) newWindow.opener = null;
        } else {
          const urlObject = new URL(url);
          const urlObjectReferenced = new URL(
            referrer_user?.media_interaction_replacement_url
          );
          const newBaseUrl = `${urlObject.protocol}//${urlObjectReferenced.hostname}`;
          var link1 =
            replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId) +
            referrer_user?.third_party_username +
            extractPathAndQuery(finalUrl.href);
          // console.log(finalUrl.href, "++linke1");
          // console.log(link1, "++linke1");
          link1 = link1.replace(
            "/testportalusaqashp",
            "/" + referrer_user?.third_party_username
          );
          // console.log(replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId));
          // console.log(link1, "++linke1");
          const newWindow = window.open(link1, "_blank", "noopener,noreferrer");
          if (newWindow) newWindow.opener = null;
        }
      } else {
        var link1 =
          extractBaseUrl(newLink) +
          `${utmDistributor}` +
          extractPathAndQuery(newLink);
        link1 = link1.replace(
          "/testportalusaqashp/testportalusaqashp",
          "/testportalusaqashp"
        );
        // console.log(link1, "++linke1");
        const newWindow = window.open(link1, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
      }
    } else if (finalUrl.href.includes("myarieyl")) {
      openLinkNewTab(
        replaceHost(
          finalUrl.href,
          referrer_user.media_interaction_replacement_url
        )
      );
    } else {
      if (referrer_user?.media_interaction_replacement_url) {
        var userId = extractNumberFromUrl(
          referrer_user?.media_interaction_replacement_url
        );
        // console.log(userId, "++userId");
        var link1 =
          replaceNumberInUrl(extractBaseUrl(finalUrl.href), userId) +
          extractPathAndQuery(finalUrl.href).substring(1);
        // console.log(link1, "++linke1");
        const newWindow = window.open(link1, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
      } else {
        const newWindow = window.open(newLink, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
      }
    }

    return "";
  };

  const replaceNumberInUrl = (url: any, newNumber: any) => {
    const regex = /^(https?:\/\/)\d+(\..+)/;
    const newUrl = url.replace(regex, `$1${newNumber}$2`);
    return newUrl;
  };

  const extractNumberFromUrl = (url: string) => {
    const regex = /^https:\/\/(\d+)\./;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const openInNewTab = (
    url: string,
    title: string,
    assetId: any,
    clientId: string,
    thirdPartyUsername: string,
    utm_distributor: string
  ): void => {
    const utmTerm = title?.replace(/ /g, "_")?.replace(/[^a-zA-Z0-9_]/g, "");

    const newURL =
      extractBaseUrl(url) +
      `${thirdPartyUsername}` +
      extractPathAndQuery(url) +
      (extractBaseUrl(url).includes("shop.com")
        ? `utm_source=${"verbLive"}`
        : `&utm_source=${"verbLive"}`) +
      `&utm_campaign=${extractMarketamer(clientId)}` +
      `&utm_term=${utmTerm}` +
      `&utm_distributor=${utm_distributor}` +
      `&utm_content=${assetId}` +
      `&sourceid=4444`;
    if (isMobile) {
      mobileClick.mobileClick(newURL);
      return;
    }
    const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const shopifyAttributionClick = (
    url: string,
    title: string,
    assetId: any,
    clientId: string,
    thirdPartyUsername: string,
    shopsitename: string
  ) => {
    const utmTerm = title?.replace(/ /g, "_")?.replace(/[^a-zA-Z0-9_]/g, "");
    const newURL =
      extractBaseUrlShopifyWithSiteName(
        url,
        shopsitename ? shopsitename : thirdPartyUsername
      ) +
      extractPathAndQueryShopify(url) +
      `&utm_source=${"verbLive"}` +
      `&utm_medium=${"verbLive"}` +
      `&utm_campaign=${extractMarketamer(clientId)}` +
      `&utm_term=${utmTerm}` +
      `&utm_distributor=${""}` +
      `&utm_content=${convertSpecialCharacters(assetId)}`;
    if (isMobile) {
      mobileClick.mobileClick(newURL);
      return;
    }
    const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const meidaAttributionClick = (
    url: string,
    title: string,
    assetId: any,
    clientId: string,
    thirdPartyUsername: string,
    referrer_user: any
  ) => {
    const utmTerm = title?.replace(/ /g, "_")?.replace(/[^a-zA-Z0-9_]/g, "");
    const newURL =
      extractBaseUrlShopify(url) +
      `${
        extractBaseUrlShopify(url).includes("crm.verb") ||
        extractBaseUrlShopify(url).includes("unfranchisemarketing") ||
        extractBaseUrlShopify(url).includes("sharezyia")
          ? extractPathAndQueryMediaMA(url) + `?utm_source=${"verbLive"}`
          : `/${thirdPartyUsername}` +
            extractPathAndQueryMediaShopCom(url) +
            `&utm_source=${"verbLive"}`
      }` +
      `&utm_medium=${"verbLive"}` +
      `&utm_campaign=${extractMarketamer(clientId)}` +
      `&utm_term=${utmTerm}` +
      `&utm_distributor=${
        referrer_user ? referrer_user?.third_party_username : ""
      }` +
      `&utm_content=${assetId}`;
    if (isMobile) {
      mobileClick.mobileClick(newURL);
      return;
    }
    const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const meidaAttributionShopifyClick = (
    url: string,
    title: string,
    assetId: any,
    clientId: string,
    thirdPartyUsername: string,
    shopsitename: string
  ) => {
    
    const utmTerm = title?.replace(/ /g, "_")?.replace(/[^a-zA-Z0-9_]/g, "");
    if (!shopsitename) {
      const newURL =
        extractBaseUrlShopify(url) +
        `${
          extractBaseUrlShopify(url).includes("crm.verb") ||
          extractBaseUrlShopify(url).includes("sharezyia")
            ? `/${thirdPartyUsername}` +
              extractPathAndQueryMedia(url) +
              `?utm_source=${"verbLive"}`
            : extractPathAndQueryMediaShopCom(url) + `&utm_source=${"verbLive"}`
        }` +
        `&utm_medium=${"verbLive"}` +
        `&utm_campaign=${extractMarketamer(clientId)}` +
        `&utm_term=${utmTerm}` +
        `&utm_distributor=${""}` +
        `&utm_content=${assetId}`;
      if (isMobile) {
        mobileClick.mobileClick(newURL);
        return;
      }
      const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    } else {
      const newURL =
        extractBaseUrlShopify(url) +
        `${
          extractBaseUrlShopify(url).includes("crm.verb") ||
          extractBaseUrlShopify(url).includes("sharezyia")
            ? `/${shopsitename}` +
              extractPathAndQueryMedia(url) +
              `?utm_source=${"verbLive"}`
            : `/${shopsitename ? shopsitename : ""}` +
              extractPathAndQueryMediaShopify(url) +
              `&utm_source=${"verbLive"}`
        }` +
        `&utm_medium=${"verbLive"}` +
        `&utm_campaign=${extractMarketamer(clientId)}` +
        `&utm_term=${utmTerm}` +
        `&utm_distributor=${""}` +
        `&utm_content=${assetId}`;
      if (isMobile) {
        mobileClick.mobileClick(newURL);
        return;
      }
      const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    }
  };

  function extractBaseUrl(url: any) {
    const urlObject = new URL(url);
    const baseUrl = `${urlObject.protocol}//${urlObject.hostname}/`;
    return baseUrl;
  }

  function extractBaseUrlShopify(url: any) {
    const urlObject = new URL(url);
    const baseUrl = `${urlObject.protocol}//${urlObject.hostname}`;
    if (
      (urlObject.hostname.includes("unfranchisemarketing") ||
        urlObject.hostname.includes("sharezyia")) &&
      referrer_user?.media_interaction_replacement_url
    ) {
      const urlObjectReferenced = new URL(
        referrer_user?.media_interaction_replacement_url
      );
      const newBaseUrl = `${urlObject.protocol}//${urlObjectReferenced.hostname}`;
      return newBaseUrl;
    }
    return baseUrl;
  }

  function convertSpecialCharacters(url: any) {
    const convertedUrl = encodeURIComponent(url);
    return convertedUrl;
  }

  function extractPathAndQuery(url: any) {
    const urlObject = new URL(url);
    const pathAndQuery =
      urlObject.pathname +
      urlObject.search.replace("publisherID=AP1701813", "");
    return pathAndQuery;
  }

  function extractPathAndQueryMediaShopCom(url: any) {
    const urlObject = new URL(url);
    const pathAndQuery =
      urlObject?.pathname +
      urlObject?.search?.replace("publisherID=AP1701813", "");
    if (referrer_user && referrer_user?.media_interaction_replacement_url) {
      const urlObjectReferenced = new URL(
        referrer_user?.media_interaction_replacement_url
      );
      const index = urlObjectReferenced.pathname.indexOf("/admin");
      const pathAndQueryUserName = urlObjectReferenced.pathname
        .slice(0, index)
        .replace("/", "");
      const indexOther = pathAndQuery.indexOf("?credituser");
      const pathAndQueryUserNameOther = pathAndQuery.slice(0, indexOther);
      const format = pathAndQueryUserNameOther.replace(
        "/testportalusaqashp",
        ""
      );
      if (urlObject.hostname.includes("shop.com")) {
        const result = `${format}?credituser=${pathAndQueryUserName}`;
        return result;
      } else {
        return format.replace("idType=produc", "idType=product");
      }
    }
    if (!referrer_user || !referrer_user?.media_interaction_replacement_url) {
      const newPathAndQuery = pathAndQuery.replace("/testportalusaqashp", "");
      return newPathAndQuery;
    }
  }
  function extractPathAndQueryMedia(url: any) {
    const urlObject = new URL(url);
    const index = urlObject.pathname.indexOf("/file");
    const pathAndQuery = urlObject.pathname.slice(index);
    return pathAndQuery;
  }
  function extractPathAndQueryMediaMA(url: any) {
    const urlObject = new URL(url);
    if (referrer_user && referrer_user?.media_interaction_replacement_url) {
      const urlObjectReferenced = new URL(
        referrer_user?.media_interaction_replacement_url
      );
      const index = urlObjectReferenced.pathname.indexOf("/admin");
      const pathAndQueryUserName = urlObjectReferenced.pathname.slice(0, index);
      const indexOther = urlObject.pathname.indexOf("/file");
      const pathAndQueryUserNameOther = urlObject.pathname.slice(indexOther);
      const result = `${pathAndQueryUserName}${pathAndQueryUserNameOther}`;
      return result.replace("/asset_redirec", "");
    }
    if (!referrer_user || !referrer_user?.media_interaction_replacement_url) {
      return urlObject?.pathname;
    }
  }

  function extractPathAndQueryMediaShopify(url: any) {
    const urlObject = new URL(url);
    const index = urlObject.href.indexOf("/shop");
    const pathAndQuery = urlObject.href.slice(index);
    return pathAndQuery.replace("page=0&", "");
  }

  function extractPathAndQueryShopify(url: any) {
    const urlObject = new URL(url);
    const pathAndQuery =
      urlObject.pathname +
      urlObject.search.replace("publisherID=AP1701813", "");
    const newPathAndQuery = pathAndQuery.replace("/CORPORATE", "");
    return newPathAndQuery;
  }

  function extractBaseUrlShopifyWithSiteName(url: any, shopsitename: any) {
    const urlObject = new URL(url);
    const baseUrl = `${urlObject.protocol}//${urlObject.hostname}/${shopsitename}`;
    return baseUrl;
  }

  function extractMarketamer(inputString: any) {
    const separatorIndex = inputString.indexOf("|");
    const marketamerPart = inputString.substring(separatorIndex + 1);
    const marketamer = marketamerPart.split("-")[0];

    return marketamer;
  }

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

  const openLinkNewTab = (dataLink: any) => {
    if (!dataLink.match(/^https?:\/\//i)) {
      dataLink = "http://" + dataLink;
    }
    if (isMobile) {
      mobileClick.mobileClick(dataLink);
      return;
    }
    const newURL = dataLink;
    const newWindow = window.open(newURL, "_blank", "noopener,noreferrer");

    if (newWindow) newWindow.opener = null;
  };

  useEffect(() => {
    dispatch(setInteractionData(interactionsAllData));
  }, [interactionsAllData]);

  const scrollToElement = (id: any) => {
    const targetElement = document.getElementById(id);
    // console.log("element In product==>", targetElement);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center", // You can change this to 'center' or 'end' if needed
      });
    }
  };


  const checkTitle = (title: string) => {
    const formattedStringFirst = title.replace(/#\d+\b\.?\s?/g, "");
    const formattedString = formattedStringFirst.replace(/[^\x20-\x7E®]/g, "");

    if (formattedString.includes("Lumire")) {
      return formattedString.replace("Lumire", "Lumière");
    }

    return formattedString.trim();
  };

  return (
    <>
      <div className="flex">
        {interactionsAllData.map((data: any, index: any) => {
          return (
            <>
              {showObject(data) && (
                <div
                  style={{
                    opacity: 0.7,
                    zIndex: 1,
                    userSelect: "none",
                    backgroundColor: data?.featured
                      ? `${getBrandColor(client)} `
                      : "white",
                  }}
                  id="interactonRowLive"
                  className={`flex h-full w-[85%] min-w-[85%] items-center pl-3 rounded-md ml-2 cursor-pointer relative`}
                  onClick={() => {
                    handleCliclonProduct(data);
                  }}
                >
                  {data?.featured && (
                    <div className="flex absolute right-2 top-2 border border-white rounded pl-1.5 pr-1.5 pt-1 pb-1">
                      {data?.featured && (
                        <img
                          src={Star}
                          style={{
                            height: "21px !important",
                            width: "21px !important",
                          }}
                        ></img>
                      )}
                    </div>
                  )}

                  {!data?.featured && (
                    <div className="flex opacity-100 absolute right-2 top-2 border border-white rounded pl-1.5 pr-1.5 pt-1 pb-1">
                      {!data?.featured && (
                        <img
                          src={Star}
                          style={{
                            height: "21px !important",
                            width: "21px !important",
                          }}
                        ></img>
                      )}
                    </div>
                  )}
                  <div
                    className="flex items-center justify-center mb-2"
                    id={data.interaction_id}
                  >
                    <div
                      className={`${
                        getInteractionTypeCheck(data?.interaction_type)
                          ? "bg-grey"
                          : ""
                      } h-[75px] min-h-[75px] min-w-[75px] w-[75px] ${
                        getInteractionTypeCheck(data?.interaction_type)
                          ? "rounded-lg border border-[#979797]"
                          : ""
                      }  flex  items-center justify-center  h-[75px] min-h-[75px] min-w-[75px] w-[75px]  mt-2 relative `}
                    >
                      {data?.interaction_type == "link" ? (
                        <img
                          src={
                            getLinkValidation(
                              data?.interaction_type,
                              data?.style?.thumbnail_url
                            )
                              ? data?.style?.thumbnail_url
                              : NoPhoto
                          }
                          alt="Icon"
                          style={
                            getLinkValidation(
                              data?.interaction_type,
                              data?.style?.thumbnail_url
                            )
                              ? { height: 68, width: 68 }
                              : { height: 28, width: 28 }
                          }
                        />
                      ) : (
                        <img
                          src={
                            getInteractionTypeCheck(data?.interaction_type)
                              ? data?.style?.thumbnail_url
                              : getIconManualInteraction(data?.interaction_icon)
                          }
                          alt="Icon"
                          style={{ height: 68, width: 68 }}
                        />
                      )}
                    </div>
                    <div className="ml-2 flex-col flex items-start pt-3 min-w-0 flex-1">
                      {data?.attributes?.labelVisible && (
                        <span
                          className={`${
                            data?.featured ? "text-white" : "text-[#595959]"
                          } font-medium mb-0`}
                          style={{
                            fontSize: "0.9rem",
                            lineHeight: "1.5rem",
                            width:
                              document.getElementById("interactonRowLive")
                                ?.offsetWidth != null
                                ? document.getElementById("interactonRowLive")!
                                    .offsetWidth - 140
                                : "100%",
                            maxWidth: "100%",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            wordBreak: "break-word",
                          }}
                          title={decodeHtmlEntities(data?.attributes?.label)}
                        >
                          {decodeHtmlEntities(data?.attributes?.label)}
                        </span>
                      )}
                      {!data?.interaction_id.includes("pdf") &&
                        !data?.interaction_type.includes("social") &&
                        !data?.interaction_type.includes("link") &&
                        !data?.interaction_id.includes("link") && (
                              <span
                            className={`text-lg	 text-[#595959] font-medium border border-[#979797] rounded-md pl-1 pr-1   ${data?.featured ? "bg-white" : ""
                              }  ${data?.attributes?.shouldShow
                                ? "opacity-100 "
                                : "opacity-50"
                              }`}
                          >
                            {decimalComponent(
                              data?.attributes?.price,
                              configurationData?.company_name
                            )}
                          </span>
                        )}
                    </div>
                  </div>
                </div>
              )}
            </>
          );
        })}
      </div>
    </>
  );
};

export default ProductsListing;
